import { Box, Typography } from '@mui/material';

const SinglesPlayerDisplay = ({ playerA, playerB }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent={'space-evenly'}
      alignItems={'center'}
      gap={1}
      p={3}>
      <Typography>{playerA}</Typography>
      <Typography variant="h6" color="primary" fontWeight="bold" sx={{ mx: 2 }}>
        VS
      </Typography>
      <Typography>{playerB}</Typography>
    </Box>
  );
};

export default SinglesPlayerDisplay;
